// extracted by mini-css-extract-plugin
export default {"root":"Search_root__ck2nM","icon":"Search_icon__OBptb","input":"Search_input__t1vcF","clearIcon":"Search_clearIcon__UiG+a"};